<template>
	<div class="My_pop _popRight _popdetails" id="POP-CAdetails-1" style="display: block;" ><!-- POP -->
		<div class="pop_right " style="right: 0px;" v-loading="loadingMask"><!-- pop_right -->
			<ul class="pop_right_header2">
				<li><h2>详情</h2></li>
				<li><btn class="pop_right_close2" name="pop-details-close" @click="closeFloat"></btn></li>
			</ul>
			<div class="pop_right_main"><!-- main -->
			
	
						<ul class="form_list">
							<!-- <li>
								<h4>咨询文章</h4>
								<div class=""><textarea class="s_textarea"  rows="2" >中央政治局会议：加大宏观政策实施力度，稳定经济大盘</textarea></div>
							</li> -->
							<li>
								<h4>咨询内容</h4>
								<div class="">
									<textarea class="s_textarea"  rows="8" v-model="zixunform.desc" maxlength="300" style="resize: none;" :readonly="!isedit"></textarea>
									<span class="grey1" style="float: right;margin-right: 20px;">{{zixunform.desc.length}}/300</span>
								</div>
							</li>
							<li>
								<h4>邮箱</h4>
								<div class=""><input type="text" class="s_input" v-model="zixunform.email" :readonly="!isedit"></div>
							</li>
							<li>
								<h4>联系电话</h4>
								<div class=""><input type="text" class="s_input"  v-model="zixunform.phone" :readonly="!isedit"></div>
							</li>
						</ul>
	
				
			</div><!-- /main -->
			
			<div class="pop_right_footer2">
				<btn class="s_btn" v-if="!isedit"  @click="isedit=1" >修改</btn>
				<btn class="s_btn" v-else  @click="updatezixun" >保存</btn>
			</div>
			
		</div><!-- /pop_right -->
		<div class="pop_bg" style="display: block;" @click="closeFloat"></div>
	</div><!-- /POP -->
</template>

<script>
	export default {
		data() {
			return {
				loadingMask:true,
				isedit:0,
				zixunDetail:'',
				zixunform: {
					desc: '',
					email:'',
					phone:''
				},
			}
		},
		props:[
			'detailid'
		],
		mounted: function() {
			this.getZixunDetailfnc();
			this.$track([
				['pagetype','查看需求咨询']
			]);
		},
		methods: {
			getZixunDetailfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/GetUserFeedback',
						responseType: 'json',
						params: {
							id: this.detailid,
						},
					})
					.then(function(response) {
						_this.zixunDetail = response.data.data.data.feedback;
						var zixunContent= JSON.parse(_this.zixunDetail.content);
						_this.zixunform.desc=zixunContent.desc;
						_this.zixunform.email=zixunContent.email;
						_this.zixunform.phone=zixunContent.phone;
						_this.$track([
							['pagetype','查看资料需求详情']
						]);
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			updatezixun:function(){
				if(!this.zixunform.desc){
					this.$message({
						message: '请填写描述',
						type: 'warning'
					});
					
					return false;
				}
				else if (!this.zixunform.email){
					this.$message({
						message: '请填写邮箱',
						type: 'warning'
					});
					
					return false;
				}
				
				if(this.zixunform.email){
					var regemail=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if(!regemail.test(this.zixunform.email)){
						this.$message({
							message: '请正确填写邮箱',
							type: 'warning'
						});
						return false;
					}
				}
				
				if(this.zixunform.phone){
					var regmobile=/^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]|14[57])[0-9]{8}$/;
					var regtel=/^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
					if((!regmobile.test(this.zixunform.phone))&&(!regtel.test(this.zixunform.phone))){
						this.$message({
							message: '请填写正确的联系电话,固定电话请添加区号',
							type: 'warning'
						});
						return false;
					}
				}
				
				var tempzixun={
					desc:this.zixunform.desc,
					email:this.zixunform.email,
					phone:this.zixunform.phone
				}
				let _this = this;
				this.$http({
						method: 'post',
						url: 'UserInfo/UpdateUserFeedback',
						responseType: 'json',
						params: {
							id:this.detailid,
							content: JSON.stringify(tempzixun)
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: '需求咨询修改成功',
								type: 'success'
							});
							_this.zixunform.desc='';
							_this.zixunform.email='';
							_this.zixunform.phone='';
							_this.closeFloat();
							_this.$track([
								['pagetype','修改资料需求']
							]);
						}
						else{
							_this.$message({
								message: '需求咨询修改失败',
								type: 'error'
							});
						}
						
					})
					.catch(function(error) {
						_this.$message({
							message: '需求咨询修改失败',
							type: 'error'
						});
						// _this.closeFloat();
						console.log(error);
					});
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
			
		},
	}
</script>

<style>
</style>
